import { render, staticRenderFns } from "./ViewAllEmailPhoneModal.vue?vue&type=template&id=b10e7b80"
import script from "./ViewAllEmailPhoneModal.vue?vue&type=script&lang=js"
export * from "./ViewAllEmailPhoneModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports